/**
 * @fileoverview Define the native calendar-date boundary for shared forms. The parent owns selection and persistence; `utils.js` preserves local calendar dates between the input and Date values. `AppCalendar.js` wraps a different picker and uses an event-envelope callback.
 */

import React from 'react'
import { formatDateForInput, parseDateInput } from './utils'

const inputStyle = {
    width: '100%',
    padding: '0.6rem 0.75rem',
    borderRadius: '6px',
    border: '1px solid var(--surface-border)',
    fontSize: '1rem',
    backgroundColor: 'var(--surface-section)',
    color: 'var(--text-color)'
}

/**
 * onChange receives a local-midnight Date or null directly. Treat it as a calendar date when crossing API boundaries; converting through UTC can change the selected day.
 */
function AppDateInput({ id, value, onChange }) {
    return (
        <input
            id={id}
            type="date"
            value={formatDateForInput(value)}
            onChange={(e) => onChange(parseDateInput(e.target.value))}
            style={inputStyle}
        />
    )
}

export default AppDateInput
